/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useState} from "react";
import TemplateStep from "../../../../../components/Wizard/Steps/TemplateStep";
import {IBaseStepProps} from "../../../../../components/Wizard/types";
import {
  useSelectErrorMessageList,
  useSelectFileUploadResponse,
  useSelectWarningMessageList
} from "../../../../../../redux/ducks/Wizard/SliceProvider";
import {LensRow} from "../../../constants";
import {lensColumns} from "../../ItemDetails/constants";

import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";

const LensStep = (props: IBaseStepProps) => {
  const {messagesTitle} = props
  /**
   * use error messages length for whether or not there is error for this data sheet
   */

  const errorMessages = useSelectErrorMessageList(2)
  const warningMessages = useSelectWarningMessageList(2)
  
  const data = useSelectFileUploadResponse()?.cosmos_data?.plotData?.lensTable
  const [reactTableData, setReactTableData] = useState<LensRow[]>([]);

  const rows = data?.rows ?? []
  useEffect(() => {
    convert_rows_list_to_object(rows)
  }, [rows])

  const convert_rows_list_to_object = (rows: any[]) => {
    let new_format_rows: LensRow[] = []
    rows.forEach((row: any[]) => {
      let row_object: LensRow = {
        fov: row[0],
        paraxial_height: row[1],
        real_height: row[2],
        op_distance: row[3],
        angular_resolution: row[4]
      }
      new_format_rows.push(row_object)
    })
    setReactTableData(new_format_rows)
  }

  const headers = data?.headers ?? []

  const title = data?.title ?? ''

  const content2 = (
    <div style={{height: '100%', width: '100%'}}>
      <ArgosTableSimple 
        data={reactTableData}
        columns={lensColumns}

        initialState={{density:'compact', pagination: {pageSize: 5, pageIndex: 0}}}
        enableTopToolbar={false}
        enableBottomToolbar
        enablePagination
      />
    </div>
  )
  return (
    <TemplateStep
      content1={null}
      content2={content2}
      errorMessages={errorMessages}
      warningMessages={warningMessages}
      messagesTitle={messagesTitle}
      isFirstWizardStep={false}
      isLastWizardStep={false}
      customTopRow={false}
      submitPopupEnabled={false}/>
  );
}

export default React.memo(LensStep)

